import validator from 'validator';

export class Validation {
  constructor() {
    this.isNonEmpty = this.isNonEmpty.bind(this);
  }

  getStateValue(formSchema = []) {
    return formSchema.reduce((prevValue, currentValue) => {
      prevValue[currentValue.name] = currentValue.defaultValue || '';
      return prevValue;
    }, {});
  }

  isFormValid(formSchema, state) {
    let isValid = true;
    for (const element of formSchema) {
      isValid = this.isElementValid(element, state[element.name]);
      if (!isValid) break;
    }

    return isValid;
  }

  isElementValid(element, value) {
    const { validation } = element;
    let isValid = true;
    if (!Array.isArray(validation) || !validation.length) return isValid;

    if (!element.notRequired || value.length) {
      isValid = this.standardValidation(validation, value);
    }

    return isValid;
  }

  standardValidation(validation, value) {
    let isValid = true;

    for (const validType of validation) {
      const validFunction = this.getValidFunction(validType);
      isValid = validFunction(value, validType);
      if (!isValid) break;
    }

    return isValid;
  }

  getValidFunction(validType) {
    const typeName = this.getTypeName(validType);

    switch (typeName) {
      case 'noEmpty':
        return this.isNonEmpty;
      case 'zipCode':
        return this.isZipCodeValid;
      case 'phone':
        return this.isPhoneValid;
      case 'email':
        return this.isEmailValid;
      case 'boolean':
        return this.isBoolTrue;
      case 'string':
        return this.isValidString;
      default:
        return () => true;
    }
  }

  getTypeName(validType) {
    if (typeof validType === 'string') return validType;
    return validType.type;
  }

  isNonEmpty(value) {
    value = String(value);
    return value.length > 0;
  }

  isPhoneValid(value) {
    value = value.replace(/\s|\+|\(|\)|-/g, '');
    return validator.isMobilePhone(value, 'en-US');
  }

  isEmailValid(value) {
    value = value.replace(/\s/g, '');
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(value).toLowerCase());
  }

  isZipCodeValid(value) {
    return validator.isPostalCode(value, 'US');
  }

  isBoolTrue(value) {
    value = !!value;
    return value;
  }

  isValidString(value, options) {
    value = String(value);
    if (options.valueLength) return value.length === options.valueLength;
    // return this.isNonEmpty(value);
  }

  isValidInteger(value, options = {}) {
    // if (options.valueLength) {
    //   value = String(value);
    //   const numbersOnly = 'aaaa'.replace(/\D/g, '');
    //   return '';
    // }

    // return this.isInteger(value);
  }

  isInteger(value) {
    if (Number.isInteger(value)) return true;
    return this.isNormalInteger(value);
  }

  isNormalInteger(str) {
    const n = Math.floor(Number(str));
    return n !== Infinity && String(n) === str && n >= 0;
  }

  getErrorMsg(element, value) {
    if (!element) return null;
    const { errorMsg } = element;
    let { validation } = element;
    if (!Array.isArray(validation)) validation = [];
    let message = null;

    if (!element.notRequired || value.length) {
      message = this.getStandardMsg(validation, value, errorMsg);
    }

    return message;
  }

  getStandardMsg(validation, value, errorMsg) {
    let message = null;

    for (const validType of validation) {
      const validFunction = this.getValidFunction(validType).bind(this);
      if (!validFunction(value, validType)) {
        message = this.getDefaultMsg(validType, errorMsg);
        break;
      }
    }

    return message;
  }

  getDefaultMsg(validType, errorMsg) {
    const typeName = this.getTypeName(validType);
    if (errorMsg) return errorMsg;
    if (validType.errorMsg) return validType.errorMsg;

    switch (typeName) {
      case 'noEmpty':
        return 'Value cannot be empty';
      case 'zipCode':
        return 'Invalid zip code';
      case 'phone':
        return 'invalid phone number';
      case 'email':
        return 'Not valid email';
      case 'boolean':
        return '';
      case 'integer':
        return 'Value is not an integer';
      default:
        return 'Not valid value';
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/validation.js